import {
  Alert,
  Button,
  Checkbox,
  Col,
  Collapse,
  ColorPicker,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Tabs,
  Segmented,
  message,
} from "antd";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { apiRequests } from "src/shared/api/api";

const { Panel } = Collapse;
const { TextArea } = Input;

const CreateSegments = ({
  visible,
  setVisible,
  onSuccess,
  initialValues: propInitialValues,
  editId,
  editMode = false,
}) => {
  const [form] = Form.useForm();
  const [updateType, setUpdateType] = useState("cron");
  const [activeTab, setActiveTab] = useState("form");
  const [jsonValue, setJsonValue] = useState("");
  const [jsonError, setJsonError] = useState(null);
  const [nomenclatures, setNomenclatures] = useState([]);
  const [categories, setCategories] = useState([]);
  const [touchedFields, setTouchedFields] = useState(new Set());

const deepClean = useCallback((obj, isRoot = true, currentTouchedFields = touchedFields) => {
    try {
      if (obj === null || typeof obj !== "object") {
        return obj;
      }

      if (Array.isArray(obj)) {
        const cleanedArray = obj
          .map(item => deepClean(item, false, currentTouchedFields))
          .filter(
            (item) =>
              item !== null &&
              item !== undefined &&
              item !== "" &&
              !(typeof item === "object" && Object.keys(item).length === 0)
          );
        return cleanedArray.length > 0 ? cleanedArray : undefined;
      }

      const cleaned = {};
      let hasValues = false;
      
      for (const key in obj) {
        const value = obj[key];
        
        if (value !== null && value !== undefined && value !== "") {
          const cleanedValue = deepClean(value, false, currentTouchedFields);
          
          const isValidValue = 
            cleanedValue !== null &&
            cleanedValue !== undefined &&
            cleanedValue !== "" &&
            !(typeof cleanedValue === "object" && Object.keys(cleanedValue).length === 0);
          
          if (isValidValue || cleanedValue === false) {
            if (isRoot) {
              if (!currentTouchedFields.has(key)) {
                if (key === 'type_of_update' && cleanedValue === 'cron') continue;
                if (key === 'update_settings') {
                  if (obj.type_of_update === 'request') continue;
                  if (cleanedValue?.interval_minutes === 5 && 
                      Object.keys(cleanedValue).length === 1) continue;
                }
                if (key === 'is_archived' && cleanedValue === false) continue;
              }
            }
            
            cleaned[key] = cleanedValue;
            hasValues = true;
          }
        }
      }
      
      return hasValues ? cleaned : undefined;
    } catch (error) {
      console.error("Ошибка в deepClean:", error);
      return obj;
    }
  }, [touchedFields]);

const handleFieldFocus = (fieldName) => {
    setTouchedFields(prev => new Set([...prev, fieldName]));
}; 

const transformToFormFormat = (values) => {
  if (!values) return values;

  const transformed = JSON.parse(JSON.stringify(values));

  if (transformed?.criteria?.purchases?.date_range) {
    const dr = transformed.criteria.purchases.date_range;
    transformed.criteria.purchases.date_range = [
      dr.gte ? moment(dr.gte, "YYYY-MM-DD") : null,
      dr.lte ? moment(dr.lte, "YYYY-MM-DD") : null,
    ];
  }

  if (transformed?.criteria?.created_at) {
    const dr = transformed.criteria.created_at;
    transformed.criteria.created_at = {
      ...dr,
      gte: dr.gte ? moment(dr.gte, "YYYY-MM-DD") : null,
      lte: dr.lte ? moment(dr.lte, "YYYY-MM-DD") : null,
    };
  }

  ["picker", "courier"].forEach((role) => {
    ["start", "finish"].forEach((key) => {
      const dt = transformed?.criteria?.[role]?.[key];
      if (dt) {
        transformed.criteria[role][key] = {
          ...dt,
          gte: dt.gte ? moment(dt.gte, "YYYY-MM-DD") : null,
          lte: dt.lte ? moment(dt.lte, "YYYY-MM-DD") : null,
        };
      }
    });
  });

  if (transformed?.criteria?.delivery_info?.delivery_date) {
    const dd = transformed.criteria.delivery_info.delivery_date;
    transformed.criteria.delivery_info.delivery_date = {
      ...dd,
      gte: dd.gte ? moment(dd.gte, "YYYY-MM-DD") : null,
      lte: dd.lte ? moment(dd.lte, "YYYY-MM-DD") : null,
    };
  }

  return transformed;
};

  const transformToApiFormat = (values) => {
    if (!values) return values;

    const transformed = JSON.parse(JSON.stringify(values));

    if (Array.isArray(transformed?.criteria?.purchases?.date_range)) {
      const [gte, lte] = transformed.criteria.purchases.date_range;
      const dateRange = {};

      if (gte && moment.isMoment(gte)) {
        dateRange.gte = gte.format("YYYY-MM-DD");
      }
      if (lte && moment.isMoment(lte)) {
        dateRange.lte = lte.format("YYYY-MM-DD");
      }

      if (Object.keys(dateRange).length > 0) {
        transformed.criteria.purchases.date_range = dateRange;
      } else {
        delete transformed.criteria.purchases.date_range;
      }
    }

    if (transformed?.criteria?.created_at) {
      const dr = transformed.criteria.created_at;
      transformed.criteria.created_at = {
        ...dr,
        gte: moment.isMoment(dr.gte) ? dr.gte.format("YYYY-MM-DD") : dr.gte,
        lte: moment.isMoment(dr.lte) ? dr.lte.format("YYYY-MM-DD") : dr.lte,
      };
    }

    ["picker", "courier"].forEach((role) => {
      ["start", "finish"].forEach((key) => {
        const dt = transformed?.criteria?.[role]?.[key];
        if (dt) {
          transformed.criteria[role][key] = {
            ...dt,
            gte: moment.isMoment(dt.gte) ? dt.gte.format("YYYY-MM-DD") : dt.gte,
            lte: moment.isMoment(dt.lte) ? dt.lte.format("YYYY-MM-DD") : dt.lte,
          };
        }
      });
    });

    if (transformed?.criteria?.delivery_info?.delivery_date) {
      const dd = transformed.criteria.delivery_info.delivery_date;
      transformed.criteria.delivery_info.delivery_date = {
        ...dd,
        gte: moment.isMoment(dd.gte) ? dd.gte.format("YYYY-MM-DD") : dd.gte,
        lte: moment.isMoment(dd.lte) ? dd.lte.format("YYYY-MM-DD") : dd.lte,
      };
    }

    return transformed;
  };

const getInitialValues = () => ({
    name: null,
    criteria: {},
    type_of_update: "cron",
    update_settings: {
      interval_minutes: 5,
    },
    is_archived: false,
    actions: {},
  });

  const getSelectOptions = useCallback(() => {
    apiRequests.nomenclature.getItems().then((data) => {
      const names = data.data.result.map((nomenclature) => nomenclature.name);
      setNomenclatures(names);
    });

    apiRequests.categories.getItems().then((data) => {
      const names = data.data.result.map((category) => category.name);
      setCategories(names);
    });
  }, []);

useEffect(() => {
  if (visible) {
    console.log("propInitialValues", propInitialValues);
    
    if (editMode || propInitialValues) {
      let values = propInitialValues || getInitialValues();
      values = transformToFormFormat(values);
      form.setFieldsValue(values);
      setUpdateType(values.type_of_update || "cron");
      const apiFormattedValues = transformToApiFormat(values);
      const cleanedValues = deepClean(apiFormattedValues, true, new Set());
      setJsonValue(JSON.stringify(cleanedValues || {}, null, 2));
    } else {
      const initialValues = getInitialValues();
      form.setFieldsValue(initialValues);
      setUpdateType("cron");
      setJsonValue("{}");
    }
    
    setActiveTab("form");
    getSelectOptions();
    setJsonError(null);
    
  } else {
    form.resetFields();
    setUpdateType("cron");
    setActiveTab("form");
    setJsonValue("{}");
    setJsonError(null);
    setTimeout(() => {
      setTouchedFields(new Set());
    }, 0);
  }
}, [visible, propInitialValues, form, getSelectOptions, editMode]); // eslint-disable-line react-hooks/exhaustive-deps

const handleFormChange = (changedValues, allValues) => {
    const changedField = Object.keys(changedValues)[0];
    setTouchedFields(prev => {
      const newSet = new Set(prev);
      newSet.add(changedField);
      if (changedField === 'type_of_update') {
        newSet.add('update_settings');
        if (changedValues.type_of_update === 'request') {
          form.setFieldsValue({
            update_settings: undefined
          });
        }
      }
      if (changedField === 'is_archived') {
        newSet.add('is_archived');
      }
      
      return newSet;
    });

    try {
      const apiFormattedValues = transformToApiFormat(allValues);
      const cleanedValues = deepClean(apiFormattedValues, true, touchedFields);
      if (!editMode && !propInitialValues && Object.keys(cleanedValues || {}).length === 0) {
        setJsonValue("{}");
      } else {
        setJsonValue(JSON.stringify(cleanedValues || {}, null, 2));
      }
      setJsonError(null);
    } catch (error) {
      setJsonError("Ошибка преобразования в JSON");
    }
  };

  const handleJsonChange = (e) => {
    const newValue = e.target.value;
    setJsonValue(newValue);

    try {
      if (newValue.trim() === "{}" || newValue.trim() === "") {
        form.setFieldsValue(getInitialValues());
        setJsonError(null);
        return;
      }
      
      const parsed = JSON.parse(newValue);
      const cleanedParsed = deepClean(parsed, true, touchedFields) || {};
      const formFormattedValues = transformToFormFormat(cleanedParsed);
      
      console.log("formFormattedValues", formFormattedValues);
      form.setFieldsValue(formFormattedValues);
      setJsonError(null);
    } catch (error) {
      setJsonError("Невалидный JSON");
    }
  };
  const formatValues = (values) => {
    const cleanEmptyValues = (obj) => {
      if (!obj) return obj;
      const cleaned = { ...obj };
      for (const key in cleaned) {
        if (
          cleaned[key] === null ||
          cleaned[key] === "" ||
          cleaned[key] === undefined
        ) {
          delete cleaned[key];
        }
      }
      return cleaned;
    };

    return {
      ...values,
      criteria: {
        ...values.criteria,
        purchases: {
          ...values.criteria.purchases,
          total_amount: cleanEmptyValues(
            values.criteria.purchases?.total_amount
          ),
          count: cleanEmptyValues(values.criteria.purchases?.count),
          last_purchase_days_ago: cleanEmptyValues(
            values.criteria.purchases?.last_purchase_days_ago
          ),
          amount_per_check: cleanEmptyValues(
            values.criteria.purchases?.amount_per_check
          ),
          categories: Array.isArray(values.criteria.purchases?.categories)
            ? values.criteria.purchases.categories
            : [],
          nomenclatures: Array.isArray(values.criteria.purchases?.nomenclatures)
            ? values.criteria.purchases.nomenclatures
            : [],
        },
        loyality: {
          ...values.criteria.loyality,
          balance: cleanEmptyValues(values.criteria.loyality?.balance),
          expires_in_days: cleanEmptyValues(
            values.criteria.loyality?.expires_in_days
          ),
        },
        delivery_info: values.criteria.delivery_info
          ? {
            ...values.criteria.delivery_info,
            delivery_date: cleanEmptyValues(
              values.criteria.delivery_info.delivery_date
            ),
            recipient: cleanEmptyValues(
              values.criteria.delivery_info.recipient
            ),
          }
          : undefined,
      },
    };
  };

const formatActions = (actions) => {

   const cleanedActions = {
  ...(actions.add_existed_tags?.name?.length > 0
    ? { add_existed_tags: actions.add_existed_tags }
    : {}),
  ...(actions.remove_tags?.name?.length > 0
    ? { remove_tags: actions.remove_tags }
    : {}),
  ...(actions.add_docs_sales_tags?.tags?.length > 0
    ? { add_docs_sales_tags: actions.add_docs_sales_tags }
    : {}),
  ...(actions.remove_docs_sales_tags?.tags?.length > 0
    ? { remove_docs_sales_tags: actions.remove_docs_sales_tags }
    : {}),
  ...(actions.client_tags?.tags?.length > 0
    ? {
        client_tags: {
          tags: actions.client_tags.tags
            .map((tag) => {
              const cleanedTag = deepClean(tag);
              return cleanedTag ? cleanedTag : undefined;
            })
            .filter((tag) => tag !== undefined),
        },
      }
    : {}),
  ...(actions.send_tg_notification &&
    (actions.send_tg_notification.trigger_on_new ||
      actions.send_tg_notification.message ||
      actions.send_tg_notification.user_tag ||
      actions.send_tg_notification.send_to)
    ? { send_tg_notification: deepClean(actions.send_tg_notification) }
    : {}),
  
  // НОВЫЕ ДЕЙСТВИЯ
  ...(actions.transform_loyality_card &&
    (actions.transform_loyality_card.cashback_percent > 0 ||
     actions.transform_loyality_card.max_withdraw_percentage > 0 ||
     actions.transform_loyality_card.lifetime > 0 ||
     actions.transform_loyality_card.tag)
    ? { transform_loyality_card: deepClean(actions.transform_loyality_card) }
    : {}),
    
  ...(actions.add_loyality_transaction &&
    (actions.add_loyality_transaction.amount > 0 ||
     actions.add_loyality_transaction.comment)
    ? { add_loyality_transaction: deepClean(actions.add_loyality_transaction) }
    : {}),
    
  ...(actions.send_wa_notification &&
    (actions.send_wa_notification.message ||
     actions.send_wa_notification.wappi_token ||
     actions.send_wa_notification.wappi_profile_id)
    ? { send_wa_notification: deepClean(actions.send_wa_notification) }
    : {}),
    
  ...(actions.do_http_request &&
    (actions.do_http_request.url)
    ? { do_http_request: deepClean(actions.do_http_request) }
    : {}),
};

    return Object.keys(cleanedActions).length > 0 ? cleanedActions : undefined;
  };

  const onFinish = (values) => {
    if (activeTab === "json") {
      try {
        const parsedJson = JSON.parse(jsonValue);
        const formattedValues = formatValues(parsedJson);
        formattedValues.actions = formatActions(formattedValues.actions);

        // Отправка данных
        if (editId) {
          apiRequests.segments.putData(editId, formattedValues).then(() => {
            setVisible(false);
            onSuccess?.();
          });
        } else {
          apiRequests.segments.postData(formattedValues).then(() => {
            setVisible(false);
            onSuccess?.();
          });
        }
      } catch (error) {
        console.error("Ошибка парсинга JSON:", error);
        message.error("Ошибка в формате JSON данных");
      }
      return;
    }
    const apiFormattedValues = transformToApiFormat(values);
    const formattedValues = formatValues(apiFormattedValues);
    formattedValues.actions = formatActions(formattedValues.actions);

    if (editId) {
      apiRequests.segments.putData(editId, formattedValues).then(() => {
        setVisible(false);
        onSuccess?.();
      });
    } else {
      apiRequests.segments.postData(formattedValues).then(() => {
        setVisible(false);
        onSuccess?.();
      });
    }
  };

const handleTabChange = (key) => {
    if (key === "json") {
      try {
        const values = form.getFieldsValue(true);
        const apiFormattedValues = transformToApiFormat(values);
        const cleanedValues = deepClean(apiFormattedValues, true, touchedFields);
        
        setJsonValue(JSON.stringify(cleanedValues || {}, null, 2));
        setJsonError(null);
      } catch (error) {
        console.error("Ошибка преобразования в JSON:", error);
        setJsonError("Ошибка преобразования в JSON");
      }
    }
    setActiveTab(key);
};

  return (
    <div>
      {!editId && !editMode && (
        <Button onClick={() => setVisible(true)} type="primary">
          Создать сегмент
        </Button>
      )}

      <Modal
        open={visible}
        title={editId ? "Редактирование сегмента" : "Создание сегмента"}
        onCancel={() => setVisible(false)}
        centered
        footer={[
          <Button key="cancel" onClick={() => setVisible(false)}>
            Отмена
          </Button>,
          <Button key="submit" type="primary" onClick={() => form.submit()}>
            {editId ? "Сохранить" : "Создать"}
          </Button>,
        ]}
        width={900}
      >
        <Tabs 
          activeKey={activeTab} 
          onChange={handleTabChange}
          items={[
            {
              key: "form",
              label: "Форма",
              children: (
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onValuesChange={handleFormChange}
            >
              {/* Основная информация */}
              <Form.Item
                label="Название сегмента"
                name="name"
                rules={[
                  { required: true, message: "Введите название сегмента" },
                ]}
              >
                <Input placeholder="Введите название" />
              </Form.Item>

              <Divider orientation="left">Критерии сегмента</Divider>

              <Collapse defaultActiveKey={["purchases", "loyality", "extra"]}>
                {/* Секция покупок */}
                <Panel header="Параметры покупок" key="purchases">
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="Общая сумма покупок"
                        style={{ marginBottom: 8 }}
                      >
                        <Input.Group compact>
                          <Form.Item
                            name={[
                              "criteria",
                              "purchases",
                              "total_amount",
                              "gte",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="От"
                              style={{ width: "33%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[
                              "criteria",
                              "purchases",
                              "total_amount",
                              "lte",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="До"
                              style={{ width: "33%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[
                              "criteria",
                              "purchases",
                              "total_amount",
                              "eq",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="Равно"
                              style={{ width: "34%" }}
                            />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>

                      <Form.Item
                        label="Количество покупок"
                        style={{ marginBottom: 8 }}
                      >
                        <Input.Group compact>
                          <Form.Item
                            name={["criteria", "purchases", "count", "gte"]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="От"
                              style={{ width: "33%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={["criteria", "purchases", "count", "lte"]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="До"
                              style={{ width: "33%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={["criteria", "purchases", "count", "eq"]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="Равно"
                              style={{ width: "34%" }}
                            />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>

                      <Form.Item
                        label="Средний чек"
                        style={{ marginBottom: 8 }}
                      >
                        <Input.Group compact>
                          <Form.Item
                            name={[
                              "criteria",
                              "purchases",
                              "amount_per_check",
                              "gte",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="От"
                              style={{ width: "33%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[
                              "criteria",
                              "purchases",
                              "amount_per_check",
                              "lte",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="До"
                              style={{ width: "33%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[
                              "criteria",
                              "purchases",
                              "amount_per_check",
                              "eq",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="Равно"
                              style={{ width: "34%" }}
                            />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>

                      <Form.Item
                        label="Последняя покупка (дней назад)"
                        name={[
                          "criteria",
                          "purchases",
                          "last_purchase_days_ago",
                        ]}
                      >
                        <Input.Group compact>
                          <Form.Item
                            name={[
                              "criteria",
                              "purchases",
                              "last_purchase_days_ago",
                              "gte",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="Не менее"
                              style={{ width: "50%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[
                              "criteria",
                              "purchases",
                              "last_purchase_days_ago",
                              "lte",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="Не более"
                              style={{ width: "50%" }}
                            />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item
                        label="Период покупок"
                        name={["criteria", "purchases", "date_range"]}
                      >
                        <DatePicker.RangePicker
                          style={{ width: "100%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        label="Категории товаров"
                        name={["criteria", "purchases", "categories"]}
                      >
                        <Select
                          mode="tags"
                          placeholder="Выберите категории"
                          tokenSeparators={[","]}
                          allowClear
                          options={categories.map((cat) => ({
                            value: cat,
                            label: cat,
                          }))}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Конкретные товары"
                        name={["criteria", "purchases", "nomenclatures"]}
                      >
                        <Select
                          mode="tags"
                          placeholder="Выберите товары"
                          tokenSeparators={[","]}
                          allowClear
                          options={nomenclatures.map((nom) => ({
                            value: nom,
                            label: nom,
                          }))}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>

                {/* Секция лояльности */}
                <Panel header="Параметры лояльности" key="loyality">
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="Баллы на счету"
                        style={{ marginBottom: 8 }}
                      >
                        <Input.Group compact>
                          <Form.Item
                            name={["criteria", "loyality", "balance", "gte"]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="От"
                              style={{ width: "33%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={["criteria", "loyality", "balance", "lte"]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="До"
                              style={{ width: "33%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={["criteria", "loyality", "balance", "eq"]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="Равно"
                              style={{ width: "34%" }}
                            />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>

                    <Col span={12}>
                      <Form.Item
                        label="Сгорание баллов (дней)"
                        name={["criteria", "loyality", "expires_in_days"]}
                      >
                        <Input.Group compact>
                          <Form.Item
                            name={[
                              "criteria",
                              "loyality",
                              "expires_in_days",
                              "gte",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="Не менее"
                              style={{ width: "50%" }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[
                              "criteria",
                              "loyality",
                              "expires_in_days",
                              "lte",
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder="Не более"
                              style={{ width: "50%" }}
                            />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
                <Panel header="Дополнительные критерии" key="extra">
                  <Form.Item label="Теги" name={["criteria", "tags"]}>
                    <Select
                      mode="tags"
                      placeholder="Введите теги"
                      tokenSeparators={[","]}
                      allowClear
                    />
                  </Form.Item>
                  <Form.Item
                    label="Теги документов продаж"
                    name={["criteria", "docs_sales_tags"]}
                  >
                    <Select
                      mode="tags"
                      placeholder="Введите теги документов продаж"
                      tokenSeparators={[","]}
                      allowClear
                    />
                  </Form.Item>
                  <Form.Item
                    label="Требуется доставка"
                    name={["criteria", "delivery_required"]}
                  >
                    <Segmented
                      options={[
                        { label: "Не задано", value: null },
                        { label: "Да", value: true },
                        { label: "Нет", value: false },
                      ]}
                      block
                    />
                  </Form.Item>
                  <Form.Item label="Дата создания" style={{ marginBottom: 8 }}>
                    <Input.Group compact>
                      <Form.Item
                        name={["criteria", "created_at", "gte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="С даты"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={["criteria", "created_at", "lte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="По дату"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={["criteria", "created_at", "gte_seconds_ago"]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (до)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        name={["criteria", "created_at", "lte_seconds_ago"]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (от)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                    </Input.Group>
                    {/* <Form.Item
                      name={["criteria", "created_at", "is_none"]}
                      valuePropName="checked"
                      style={{ marginTop: 8 }}
                    >
                      <Checkbox>is_none</Checkbox>
                    </Form.Item> */}
                  </Form.Item>
                </Panel>
                <Panel header="Информация о доставке" key="delivery_info">
                  <Form.Item
                    label="Адрес доставки"
                    name={["criteria", "delivery_info", "address"]}
                  >
                    <Input placeholder="Введите адрес" />
                  </Form.Item>

                  <Form.Item
                    label="Дата доставки"
                    name={["criteria", "delivery_info", "delivery_date"]}
                  >
                    <Input.Group compact>
                      <Form.Item
                        name={[
                          "criteria",
                          "delivery_info",
                          "delivery_date",
                          "gte",
                        ]}
                        noStyle
                      >
                        <DatePicker
                          placeholder="С даты"
                          style={{ width: "33%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "delivery_info",
                          "delivery_date",
                          "lte",
                        ]}
                        noStyle
                      >
                        <DatePicker
                          placeholder="По дату"
                          style={{ width: "33%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "delivery_info",
                          "delivery_date",
                          "gte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (до)"
                          style={{ width: "17%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "delivery_info",
                          "delivery_date",
                          "lte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (от)"
                          style={{ width: "17%" }}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>

                  <Form.Item
                    label="Примечание"
                    name={["criteria", "delivery_info", "note"]}
                  >
                    <Input.TextArea placeholder="Введите примечание" />
                  </Form.Item>

                  <Divider orientation="left">Получатель</Divider>

                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        label="Имя"
                        name={[
                          "criteria",
                          "delivery_info",
                          "recipient",
                          "name",
                        ]}
                      >
                        <Input placeholder="Имя получателя" />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Фамилия"
                        name={[
                          "criteria",
                          "delivery_info",
                          "recipient",
                          "surname",
                        ]}
                      >
                        <Input placeholder="Фамилия получателя" />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Телефон"
                        name={[
                          "criteria",
                          "delivery_info",
                          "recipient",
                          "phone",
                        ]}
                      >
                        <Input placeholder="Телефон получателя" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
                <Panel header="Сборщик" key="picker">
                  <Form.Item
                    name={["criteria", "picker", "assigned"]}
                    label="Назначен"
                  >
                    <Segmented
                      options={[
                        { label: "Не задано", value: null },
                        { label: "Да", value: true },
                        { label: "Нет", value: false },
                      ]}
                      block
                    />
                  </Form.Item>
                  <Form.Item label="Сборщик начал" style={{ marginBottom: 8 }}>
                    <Input.Group compact>
                      <Form.Item
                        name={["criteria", "picker", "start", "gte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="С даты (gte)"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={["criteria", "picker", "start", "lte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="По дату (lte)"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "picker",
                          "start",
                          "gte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (до)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "picker",
                          "start",
                          "lte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (от)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                    </Input.Group>
                    {/* <Form.Item
                      name={["criteria", "picker", "start", "is_none"]}
                      valuePropName="checked"
                      style={{ marginTop: 8 }}
                    >
                      <Checkbox>is_none</Checkbox>
                    </Form.Item> */}
                  </Form.Item>
                  <Form.Item
                    label="Сборщик закончил"
                    style={{ marginBottom: 8 }}
                  >
                    <Input.Group compact>
                      <Form.Item
                        name={["criteria", "picker", "finish", "gte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="С даты (gte)"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={["criteria", "picker", "finish", "lte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="По дату (lte)"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "picker",
                          "finish",
                          "gte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (до)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "picker",
                          "finish",
                          "lte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (от)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Сборщик не добавил фотографии позже (минуты):"
                        name={["criteria", "picker", "photos_not_added_minutes"]}
                        style={{ marginTop: 8 }}
                      >
                        <InputNumber
                          placeholder="Введите минуты"
                          min={1}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Input.Group>

                  </Form.Item>


                </Panel>
                <Panel header="Курьер" key="courier">
                  <Form.Item
                    name={["criteria", "courier", "assigned"]}
                    label="Назначен"
                  >
                    <Segmented
                      options={[
                        { label: "Не задано", value: null },
                        { label: "Да", value: true },
                        { label: "Нет", value: false },
                      ]}
                      block
                    />
                  </Form.Item>
                  <Form.Item label="Курьер начал" style={{ marginBottom: 8 }}>
                    <Input.Group compact>
                      <Form.Item
                        name={["criteria", "courier", "start", "gte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="С даты (gte)"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={["criteria", "courier", "start", "lte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="По дату (lte)"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "courier",
                          "start",
                          "gte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (до)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "courier",
                          "start",
                          "lte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (от)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                    </Input.Group>
                    {/* <Form.Item
                      name={["criteria", "courier", "start", "is_none"]}
                      valuePropName="checked"
                      style={{ marginTop: 8 }}
                    >
                      <Checkbox>is_none</Checkbox>
                    </Form.Item> */}
                  </Form.Item>
                  <Form.Item
                    label="Курьер закончил"
                    style={{ marginBottom: 8 }}
                  >
                    <Input.Group compact>
                      <Form.Item
                        name={["criteria", "courier", "finish", "gte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="С даты (gte)"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={["criteria", "courier", "finish", "lte"]}
                        noStyle
                        getValueProps={(value) => ({
                          value:
                            value && value.isValid && value.isValid()
                              ? value
                              : null,
                        })}
                      >
                        <DatePicker
                          placeholder="По дату (lte)"
                          style={{ width: "30%" }}
                          format="YYYY-MM-DD"
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "courier",
                          "finish",
                          "gte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (до)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                      <Form.Item
                        name={[
                          "criteria",
                          "courier",
                          "finish",
                          "lte_seconds_ago",
                        ]}
                        noStyle
                      >
                        <InputNumber
                          placeholder="Сек. назад (от)"
                          style={{ width: "20%" }}
                        />
                      </Form.Item>
                    </Input.Group>
                    {/* <Form.Item
                      name={["criteria", "courier", "finish", "is_none"]}
                      valuePropName="checked"
                      style={{ marginTop: 8 }}
                    >
                      <Checkbox>is_none</Checkbox>
                    </Form.Item> */}
                  </Form.Item>
                </Panel>
              </Collapse>
              <Collapse style={{ marginTop: 16 }}>
  <Panel
    header={<span style={{ color: "orange" }}>Действия</span>}
    key="actions"
  >
    <Tabs
      type="card"
      size="small"
      items={[
        {
          label: 'Основные теги',
          key: 'basic_tags',
          children: (
            <>
              <Form.Item
                label="Добавить существующие теги"
                name={["actions", "add_existed_tags", "name"]}
              >
                <Select
                  mode="tags"
                  placeholder="Введите теги для добавления"
                  tokenSeparators={[","]}
                  allowClear
                />
              </Form.Item>
              <Form.Item
                label="Удалить теги"
                name={["actions", "remove_tags", "name"]}
              >
                <Select
                  mode="tags"
                  placeholder="Введите теги для удаления"
                  tokenSeparators={[","]}
                  allowClear
                />
              </Form.Item>
              <Form.Item label="Клиентские теги (client_tags)" shouldUpdate>
                {() => {
                  const tags = form.getFieldValue(["actions", "client_tags", "tags"]) || [];
                  return (
                    <div>
                      {tags.map((tag, idx) => (
                        <Input.Group compact key={idx} style={{ marginBottom: 8 }}>
                          <Form.Item
                            name={["actions", "client_tags", "tags", idx, "name"]}
                            noStyle
                          >
                            <Input placeholder="Имя" style={{ width: "25%" }} />
                          </Form.Item>
                          <Form.Item
                            name={["actions", "client_tags", "tags", idx, "emoji"]}
                            noStyle
                          >
                            <Input placeholder="Эмоджи" style={{ width: "15%" }} />
                          </Form.Item>
                          <Form.Item
                            name={["actions", "client_tags", "tags", idx, "color"]}
                            noStyle
                            getValueFromEvent={(color) =>
                              typeof color === "string" ? color : color?.toHexString?.() || ""
                            }
                          >
                            <ColorPicker showText format="hex" />
                          </Form.Item>
                          <Form.Item
                            name={["actions", "client_tags", "tags", idx, "description"]}
                            noStyle
                          >
                            <Input placeholder="Описание" style={{ width: "30%" }} />
                          </Form.Item>
                          <Button
                            danger
                            onClick={() => {
                              const newTags = [...tags];
                              newTags.splice(idx, 1);
                              form.setFieldsValue({
                                actions: { client_tags: { tags: newTags } },
                              });
                            }}
                          >
                            Удалить
                          </Button>
                        </Input.Group>
                      ))}
                      <Button
                        type="dashed"
                        onClick={() => {
                          form.setFieldsValue({
                            actions: {
                              client_tags: {
                                tags: [
                                  ...tags,
                                  {
                                    name: "",
                                    emoji: "",
                                    color: "#038bDB",
                                    description: "",
                                  },
                                ],
                              },
                            },
                          });
                        }}
                      >
                        Добавить тег
                      </Button>
                    </div>
                  );
                }}
              </Form.Item>
              <Form.Item
                label="Добавить теги документов продаж"
                name={["actions", "add_docs_sales_tags", "tags"]}
              >
                <Select
                  mode="tags"
                  placeholder="Введите теги для добавления"
                  tokenSeparators={[","]}
                  allowClear
                />
              </Form.Item>
              <Form.Item
                label="Удалить теги документов продаж"
                name={["actions", "remove_docs_sales_tags", "tags"]}
              >
                <Select
                  mode="tags"
                  placeholder="Введите теги для удаления"
                  tokenSeparators={[","]}
                  allowClear
                />
              </Form.Item>
            </>
          ),
        },
        {
          label: 'TG Уведомления',
          key: 'tg_notifications',
          children: (
            <>
              <Form.Item
                name={["actions", "send_tg_notification", "trigger_on_new"]}
                label="TG-уведомление: включить триггер при новом"
              >
                <Segmented
                  options={[
                    { label: "Не задано", value: null },
                    { label: "Да", value: true },
                    { label: "Нет", value: false },
                  ]}
                  block
                />
              </Form.Item>
              <Form.Item
                label="TG-уведомление: сообщение"
                name={["actions", "send_tg_notification", "message"]}
              >
                <Input placeholder="Текст сообщения" />
              </Form.Item>
              <Form.Item
                name={["actions", "send_tg_notification", "shift_status"]}
                label="TG-уведомление: для сотрудников"
              >
                <Segmented
                  options={[
                    { label: "Не задано", value: null },
                    { label: "На смене", value: "on_shift" },
                    { label: "Не на смене", value: "off_shift" },
                    { label: "На перерыве", value: "on_break" },
                  ]}
                  block
                />
              </Form.Item>
              <Form.Item
                label="TG-уведомление: user_tag"
                name={["actions", "send_tg_notification", "user_tag"]}
              >
                <Input placeholder="User tag" />
              </Form.Item>
              <Form.Item
                label="TG-уведомление: отправить кому"
                name={["actions", "send_tg_notification", "send_to"]}
              >
                <Select
                  options={[
                    { value: "picker", label: "Сборщик" },
                    { value: "courier", label: "Курьер" },
                  ]}
                />
              </Form.Item>
            </>
          ),
        },
        {
          label: 'Карты лояльности',
          key: 'loyality_cards',
          children: (
            <>
              <Form.Item
                label="Процент кэшбека"
                name={["actions", "transform_loyality_card", "cashback_percent"]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                label="Максимальный процент списания"
                name={["actions", "transform_loyality_card", "max_withdraw_percentage"]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                label="Время жизни (секунды)"
                name={["actions", "transform_loyality_card", "lifetime"]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                label="Тег карты"
                name={["actions", "transform_loyality_card", "tag"]}
              >
                <Input placeholder="Введите тег" />
              </Form.Item>
              <Form.Item
                label="Реклама для Apple Wallet"
                name={["actions", "transform_loyality_card", "apple_wallet_advertisement"]}
              >
                <TextArea placeholder="TableCRM"></TextArea>
                </Form.Item>
            </>
          ),
        },
        {
          label: 'Транзакции лояльности',
          key: 'loyality_transactions',
          children: (
            <>
              <Form.Item
                label="Сумма транзакции"
                name={["actions", "add_loyality_transaction", "amount"]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                label="Направление"
                name={["actions", "add_loyality_transaction", "direction"]}
              >
                <Select>
                  <Select.Option value="plus">Начисление (+)</Select.Option>
                  <Select.Option value="minus">Списание (-)</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Комментарий"
                name={["actions", "add_loyality_transaction", "comment"]}
              >
                <Input placeholder="Комментарий к транзакции" />
              </Form.Item>
            </>
          ),
        },
        {
          label: 'WhatsApp',
          key: 'whatsapp',
          children: (
            <>
              <Form.Item
                name={["actions", "send_wa_notification", "trigger_on_new"]}
                valuePropName="checked"
              >
                <Checkbox>Триггер при новом контрагенте</Checkbox>
              </Form.Item>
              <Form.Item
                label="Сообщение"
                name={["actions", "send_wa_notification", "message"]}
              >
                <Input.TextArea placeholder="Текст WhatsApp сообщения" />
              </Form.Item>
              <Form.Item
                label="Wappi Token"
                name={["actions", "send_wa_notification", "wappi_token"]}
              >
                <Input placeholder="Токен Wappi" />
              </Form.Item>
              <Form.Item
                label="Wappi Profile ID"
                name={["actions", "send_wa_notification", "wappi_profile_id"]}
              >
                <Input placeholder="ID профиля Wappi" />
              </Form.Item>
              <Form.Item
                label="Задержка (секунды)"
                name={["actions", "send_wa_notification", "sleep"]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </>
          ),
        },
        {
          label: 'HTTP Запросы',
          key: 'http_requests',
          children: (
            <>
              <Form.Item
                name={["actions", "do_http_request", "trigger_on_new"]}
                valuePropName="checked"
              >
                <Checkbox>Триггер при новом контрагенте</Checkbox>
              </Form.Item>
              <Form.Item
                label="Метод"
                name={["actions", "do_http_request", "method"]}
              >
                <Select>
                  <Select.Option value="GET">GET</Select.Option>
                  <Select.Option value="POST">POST</Select.Option>
                  <Select.Option value="PUT">PUT</Select.Option>
                  <Select.Option value="DELETE">DELETE</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="URL"
                name={["actions", "do_http_request", "url"]}
              >
                <Input placeholder="https://example.com/api" />
              </Form.Item>
              <Form.Item
                label="Заголовки (JSON)"
                name={["actions", "do_http_request", "headers"]}
              >
                <Input.TextArea placeholder='{"Content-Type": "application/json"}' rows={2} />
              </Form.Item>
              <Form.Item
                label="Параметры (JSON)" 
                name={["actions", "do_http_request", "params"]}
              >
                <Input.TextArea placeholder='{"param": "value"}' rows={2} />
              </Form.Item>
              <Form.Item
                label="Тело запроса (JSON)"
                name={["actions", "do_http_request", "body"]}
              >
                <Input.TextArea placeholder='{"key": "value"}' rows={2} />
              </Form.Item>
              <Form.Item
                label="Задержка (секунды)"
                name={["actions", "do_http_request", "sleep"]}
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </>
          ),
        },
      ]}
    />
  </Panel>
</Collapse>

 <Divider orientation="left">Настройки обновления</Divider>

        <Form.Item name="type_of_update" label="Тип обновления">
          <Radio.Group onChange={(e) => setUpdateType(e.target.value)}>
            <Radio value="request">Вручную</Radio>
            <Radio value="cron">По расписанию</Radio>
          </Radio.Group>
        </Form.Item>

        {updateType === "cron" && (
          <Form.Item
            label="Интервал обновления (минуты)"
            name={["update_settings", "interval_minutes"]}
            rules={[{ required: true, message: "Укажите интервал" }]}
          >
            <InputNumber 
              min={1} 
              style={{ width: "100%" }} 
              onFocus={() => handleFieldFocus('update_settings')}
            />
          </Form.Item>
        )}

        <Form.Item name="is_archived" valuePropName="checked">
          <Checkbox>Архивировать сегмент</Checkbox>
        </Form.Item>
      </Form>
              ),
            },
            {
              key: "json",
              label: "JSON",
              children: (
                <>
                  {jsonError && (
                    <Alert
                      message={jsonError}
                      type="error"
                      showIcon
                      style={{ marginBottom: 16 }}
                    />
                  )}
                  <TextArea
                    rows={20}
                    value={jsonValue}
                    onChange={handleJsonChange}
                    style={{ fontFamily: "monospace", fontSize: 14 }}
                  />
                  <div style={{ marginTop: 8, color: "#666" }}>
                    <small>
                      Изменения в JSON автоматически синхронизируются с формой
                    </small>
                  </div>
                </>
              ),
            },
          ]}
        />
      </Modal>
    </div>
  );
};

export default CreateSegments;